function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useMemo } from 'react';
import states from './states';
import Select from '../select';
const OPTIONS = states.map(({
  name,
  abbreviation,
  isTerritory = false
}) => ({
  value: abbreviation,
  label: name,
  isTerritory
}));
export const StateSelect = ({
  maxHeight = 250,
  excludeTerritories = false,
  ...props
}) => {
  const filteredOptions = useMemo(() => getFilteredOptions(excludeTerritories), [excludeTerritories]);
  return /*#__PURE__*/React.createElement(Select, _extends({
    options: filteredOptions
  }, props, {
    maxHeight: maxHeight,
    searchable: true
  }));
};
export const getFilteredOptions = (excludeTerritories = false) => {
  if (excludeTerritories) {
    return OPTIONS.filter(option => !option?.isTerritory);
  }
  return OPTIONS;
};
export default StateSelect;
//# sourceMappingURL=index.js.map